// extracted by mini-css-extract-plugin
module.exports = {"mapStats":"MapStats_mapStats__y5FMN"};